import { APP_LOGO, APP_NAME } from "@/lib/branding";
import { cn } from "@/lib/utils";

interface BrandLogoProps {
  /** Classes da imagem. O chamador manda na altura e no recorte. */
  className?: string;
  /** Classes do texto usado quando a marca não tem logótipo. */
  fallbackClassName?: string;
}

/**
 * O logótipo da marca, ou o nome dela quando não há logótipo.
 *
 * Uma marca pode não ter imagem — e `APP_LOGO` é vazio nesse caso, de
 * propósito: o fallback de um logótipo em falta nunca pode ser o logótipo de
 * outro cliente. Mas `<img src="">` desenha um ícone de imagem partida, que é
 * pior do que não mostrar nada.
 *
 * Aqui, sem logótipo mostra-se o nome — que nunca é vazio. É o que faz uma
 * marca nova funcionar antes de ter identidade visual, em vez de aparecer
 * partida ou com a cara de outra empresa.
 */
export function BrandLogo({ className, fallbackClassName }: BrandLogoProps) {
  if (!APP_LOGO) {
    return <span className={cn("truncate font-light tracking-tight", fallbackClassName)}>{APP_NAME}</span>;
  }
  return <img src={APP_LOGO} alt={APP_NAME} className={className} />;
}
